<div class="summernote-container">
    <div
        #summernote
        [ngxSummernote]="config"
        [ngxSummernoteView]="initialHtml"
        (summernoteModelChange)="onContentChange($event)"
    ></div>
</div>
<!-- #summernote -->
